// extracted by mini-css-extract-plugin
module.exports = {"flexIt":"style__flexIt__P9BK8","small":"style__small__XsXU2","visuals":"style__visuals__aXCNw"};